/** Title placeholders when recording an expense (keyed by category code). */
export const CATEGORY_TITLE_PLACEHOLDERS = {
    salary: "e.g. May 2025 staff salaries",
    educational_materials: "e.g. Term 2 textbooks and stationery",
    maintenance: "e.g. Plumbing repair — science block",
    trips: "e.g. Form 3 museum trip transport",
    awards: "e.g. Inter-house sports trophies",
    other: "Brief description of this expense",
};

/** Payee field hints per category code. */
export const CATEGORY_PAYEE_HINTS = {
    salary: "Staff name or payroll batch (e.g. All teaching staff)",
    educational_materials: "Bookshop, supplier, or vendor name",
    maintenance: "Contractor, technician, or utility (e.g. ESCOM)",
    trips: "Transport company, venue, or trip coordinator",
    awards: "Trophy shop, printer, or event supplier",
    other: "Who received the payment",
};

export function categoryTitlePlaceholder(code) {
    return CATEGORY_TITLE_PLACEHOLDERS[code] || CATEGORY_TITLE_PLACEHOLDERS.other;
}

export function categoryPayeeHint(code) {
    return CATEGORY_PAYEE_HINTS[code] || CATEGORY_PAYEE_HINTS.other;
}

const CATEGORY_NAME_TO_CODE = {
    "salary & payroll": "salary",
    "educational materials": "educational_materials",
    "maintenance & repairs": "maintenance",
    "trips & transport": "trips",
    "awards & recognition": "awards",
    "other expenses": "other",
};

export function categoryCodeFromCategory(cat) {
    if (!cat) return "other";
    if (cat.code) return cat.code;
    const key = String(cat.name || "").trim().toLowerCase();
    return CATEGORY_NAME_TO_CODE[key] || "other";
}

export function isSalaryCategory(cat) {
    return categoryCodeFromCategory(cat) === "salary";
}

export function findCategoryById(categories, id) {
    if (!id || !Array.isArray(categories)) return null;
    return categories.find((c) => (c._id || c.id) === id) || null;
}
